<div
  class="calculation-container calculationPage"
>
  <div class="calculation-header">
    <h1
      class="calculation-title defaultBackgroundColor"
      appConfigSettingsTitle
      appConfigSettingsBackground
    >
      {{ "Calculation.Title" | translate }}
    </h1>
  </div>
  <div class="navigation">
    <app-navigation-component
      (navigationStepsReady)="setActiveStep()"
      [productType]="productType"
    ></app-navigation-component>
  </div>
  <div class="columns column1">
    <app-intermediary-component
      placeholder="Calculate.Intermediary"
      required
    ></app-intermediary-component>
    <div>
      <h2 appConfigSettingsSecondTitle>
        {{ "Calculation.FirstInsured" | translate }}
      </h2>
    </div>
    <app-calculation-insured-component
      [formGroup]="formGroup.get('insured')"
      (insuredDataChanged)="paramsHaveUpdated()"
      [inputColor]="configSettings.inputColor"
      [inputBorderColor]="configSettings.inputBorderColor"
    ></app-calculation-insured-component>
    <div appConfigSettingsInput>
      <app-select-box
        placeholder="Calculation.TypeOfCover"
        [form]="formGroup"
        [optionsList]="coverTypeList"
        [control]="formGroup.get('typeOfCover')"
        (selectedOption)="paramsHaveUpdated()"
        [textColor]="configSettings.inputColor"
        [inputColor]="configSettings.inputColor"
        [backgroundHoverColor]="configSettings.backgroundColor"
        [backgroundHoverTextColor]="configSettings.backgroundTextColor"
        [fontFamily]="FontTypeEnum[configSettings.fontType]"
        [fontColor]="configSettings.fontColor"
        appConfigSettingsParagraph
        appConfigSettingsBackground
        additionalInfoInsurer="TypeOfCoverInfo.General"
      ></app-select-box>
      <ng-container
        *ngIf="formGroup.value.typeOfCover == CoverTypeEnum.ANNUITY_DECREASING"
      >
        <app-text-input
          placeholder="Calculation.AnnuityRate"
          [form]="formGroup"
          [control]="formGroup.get('annuityRate')"
          (change)="paramsHaveUpdated()"
          inputMask="percent"
          [dropSpecialCharacters]="false"
          suffix="% "
          [inputColor]="configSettings.inputColor"
          appConfigSettingsParagraph
          additionalInfoInsurer="AdditionalInformation.AnnuityRate"
          [inputMask]="annuityRateFormat"
        ></app-text-input>
      </ng-container>

      <app-select-box
        class="yearInput"
        placeholder="Calculation.DateOfCommencement"
        [form]="formGroup"
        [control]="formGroup.get('dateOfCommencement')"
        (selectedOption)="paramsHaveUpdated()"
        [optionsList]="datesArray"
        required
        isRequiredMessageKey="Calculation.RequiredField"
        [textColor]="configSettings.inputColor"
        [inputColor]="configSettings.inputColor"
        [fontFamily]="FontTypeEnum[configSettings.fontType]"
        [backgroundHoverColor]="configSettings.backgroundColor"
        [backgroundHoverTextColor]="configSettings.backgroundTextColor"
        [fontColor]="configSettings.fontColor"
      ></app-select-box>
      <app-text-input
        placeholder="Calculation.NumberOfYears"
        [form]="formGroup"
        inputMask="0*"
        [control]="formGroup.get('numberOfYears')"
        (change)="paramsHaveUpdated()"
        required
        isRequiredMessageKey="Calculation.RequiredField"
        [inputColor]="configSettings.inputColor"
        appConfigSettingsParagraph
        additionalInfoInsurer="AdditionalInformation.NumberOfYears"
      ></app-text-input>
      <app-toggle-input
        placeholder="Calculation.IsSecondInsuredPresent"
        [form]="formGroup"
        [optionsList]="yesNoList"
        [control]="formGroup.get('secondInsuredPresent')"
        (click)="paramsHaveUpdated()"
        appConfigSettingsParagraph
        additionalInfoInsurer="AdditionalInformation.SecondInsurer"
        required
        isRequiredMessageKey="Calculation.RequiredField"
      ></app-toggle-input>
      <div *ngIf="!isSecondInsured()" class="mt-20 buttons-control-container">
        <button
          type="button"
          appConfigSettingsPrimaryButton
          class="save-btn primary"
          color="primary"
          (click)="doCalculation()"
        >
          {{ "Calculation.Calculate" | translate }}
        </button>
      </div>
    </div>
  </div>
  <div class="columns column2">
    <ng-container *ngIf="isSecondInsured()">
      <div>
        <h2 appConfigSettingsSecondTitle>
          {{ "Calculation.SecondInsured" | translate }}
        </h2>
      </div>
      <app-calculation-insured-component
        [formGroup]="formGroup.get('secondInsured')"
        [secondInsured]="true"
        (insuredDataChanged)="paramsHaveUpdated()"
        [inputColor]="configSettings.inputColor"
        [inputBorderColor]="configSettings.inputBorderColor"
      ></app-calculation-insured-component>
      <div *ngIf="isSecondInsured()" class="secondColumnCalculateBtn">
        <button
          type="button"
          appConfigSettingsPrimaryButton
          class="save-btn primary"
          color="primary"
          (click)="doCalculation()"
        >
          {{ "Calculation.Calculate" | translate }}
        </button>
      </div>
    </ng-container>
    <div
      class="premium-block"
      appConfigSettingsBackground
      *ngIf="offersDataSource !== null"
    >
      <div class="displayInLine">
        <h2
          class="premiums-title"
          appConfigSettingsTitle
          appConfigSettingsBackground
        >
          {{ "Calculation.Premiums" | translate }}
          <mat-icon
            class="infoIcon"
            (click)="openPopup('AdditionalInformation.PremiumResult')"
            type="button"
          >
            info
          </mat-icon>
        </h2>
      </div>
      <div
        class="additionalContainer"
        [style.fontFamily]="FontTypeEnum[configSettings.fontType]"
      >
        {{"AdditionalInformation.AdditionalInfoPremium" | translate}}
      </div>
      <label
        class="displayFlex"
      >
        <p
          [style.fontFamily]="FontTypeEnum[configSettings.fontType]"
        >
          {{ "Calculation.BestPremium" | translate }}
        </p>
      </label>
      <div
        class="inLine premium-container"
        [style.borderColor]="configSettings.backgroundTextColor"
        [style.fontFamily]="FontTypeEnum[configSettings.fontType]"
      >
        <div class="best-premium-container">
          <span>
            <strong>
              {{selectedBestPremium.insurer}}
            </strong>
          </span>
          <span class="premium">
            <strong>
              {{selectedBestPremium.premium | currency:'EUR':undefined:undefined:'nl'}}
            </strong>
          </span>
        </div>
      </div>
      <div class="insurer-container">
        <app-premiums-overview
          [value]="premiums.insurer"
          placeholder="Calculation.ShowPremiums"
          [form]="formGroup"
          [optionsList]="offersDataSource"
          [control]="formGroup.get('premiums')"
          [textColor]="configSettings.backgroundTextColor"
          [fontFamily]="FontTypeEnum[configSettings.fontType]"
          [inputBorderColor]="configSettings.inputBorderColor"
          required
          (selectPremiumHandler)="getSelectPremium($event)"
        ></app-premiums-overview>
      </div>
    </div>
    <div class="buttons-control-container">
      <ng-container *ngIf="isPremiumsCalculated()">
        <button
          class="calculationButtons"
          type="button"
          appConfigSettingsButton
          (click)="downloadQuote()"
        >
          {{ "Calculation.Quote" | translate }}
        </button>
        <button
          class="calculationButtons primary"
          type="submit"
          appConfigSettingsPrimaryButton
          (click)="applicationResult()"
          [routerLink]="this.relativePath + '/application'"
        >
          {{ "Calculation.Application" | translate }}
        </button>
      </ng-container>
    </div>
    <app-notification-block
      [notification]="this.notificationEvent"
      appConfigSettingsParagraph
    ></app-notification-block>
  </div>
</div>
